var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',{staticClass:"base-row-padded"},[_c('b-col',[_c('PlaylistsViewer',{attrs:{"playlist-type":'loop-playlists'}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }